import { render, staticRenderFns } from "./McrFormDetail.vue?vue&type=template&id=1f941782"
import script from "./McrFormDetail.vue?vue&type=script&lang=js"
export * from "./McrFormDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports